import apiClient from "./axios";

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const fetchAvailability = async (date) => {
    const response = await apiClient.get("/appointments/availability", { params: { date } });
    return response.data.slots;
};

export const bookAppointment = async (appointment) => {
    const response = await apiClient.post("/appointments/", appointment);
    return response.data;
};

export const fetchBookingLink = async (token) => {
    const response = await apiClient.get(`/appointments/links/${token}`);
    return response.data;
};

// Admin
export const fetchAppointments = async (token) => {
    const response = await apiClient.get("/appointments/", auth(token));
    return response.data;
};

export const cancelAppointment = async (appointmentId, token) => {
    const response = await apiClient.delete(`/appointments/${appointmentId}`, auth(token));
    return response.data;
};

export const fetchBookingLinks = async (token) => {
    const response = await apiClient.get("/appointments/links", auth(token));
    return response.data;
};

export const createBookingLink = async (link, token) => {
    const response = await apiClient.post("/appointments/links", link, auth(token));
    return response.data;
};

export const deleteBookingLink = async (linkId, token) => {
    const response = await apiClient.delete(`/appointments/links/${linkId}`, auth(token));
    return response.data;
};
